import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ad-api-error-dialog',
  template: `
    <h1 mat-dialog-title>ERROR</h1>
    <div mat-dialog-content>
      <div>
        @switch (data.status) {
          <!-- HTTP 400 -->
          @case (400) {
            <h4>Please fix the following validation errors:</h4>
            @if (jsonError) {
              @if (jsonError.errors) {
                <ul>
                  @for (member of jsonError.errors | keyvalue; track member) {
                    <li>
                      <strong>{{ member.key }}:</strong> {{ member.value | json }}
                    </li>
                  }
                </ul>
              } @else {
                <p>{{ jsonError | json }}</p>
              }
            }
          }
          <!-- HTTP 429 -->
          @case (429) {
            <h4>Limit exceeded:</h4>
            @if (data.message) {
              <p>{{ data.message }}</p>
            } @else {
              <p>{{ data.error || data | json }}</p>
            }
          }
          <!-- Other Errors -->
          @default {
            <strong>HTTP {{ data.status }}:</strong> {{ textError || data.error || data | json }}
          }
        }
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button [mat-dialog-close]="data" cdkFocusInitial>OK</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class ApiErrorDialogComponent implements OnInit {
  public jsonError: any;
  public textError!: string;

  constructor(
    public dialogRef: MatDialogRef<ApiErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.error) {
      if (typeof data.error === 'string') {
        try {
          this.jsonError = JSON.parse(data.error);
        } catch (error) {
          console.error(error);
        }
      } else {
        this.jsonError = data.error;
      }
    }
  }

  async ngOnInit(): Promise<void> {
    if (!this.jsonError) {
      this.textError = await this.data;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
